/**
 * Centralized API Configuration
 *
 * This is the SINGLE source of truth for API URLs in the application.
 * All components should import from here instead of defining their own API_URL.
 *
 * Usage:
 *   import { API_URL } from '../config/api';
 *   or
 *   import api from '../config/api';  // Use axios instance with auth
 */

// Base API URL from environment variable
// Falls back to localhost:5000 for development
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// API endpoints (for better maintainability)
export const API_ENDPOINTS = {
  // Auth
  auth: {
    login: '/api/auth/login',
    logout: '/api/auth/logout',
    refresh: '/api/auth/refresh',
    me: '/api/auth/me',
    register: '/api/auth/register',
  },

  // Students
  students: {
    base: '/api/students',
    byId: (id) => `/api/students/${id}`,
    assignments: (id) => `/api/students/${id}/assignments`,
    assignmentsReplace: (id) => `/api/students/${id}/assignments/replace`,
    import: '/api/students/import',
    deleteAll: '/api/students/all',
  },

  // Coaches
  coaches: {
    base: '/api/coaches',
    byId: (id) => `/api/coaches/${id}`,
  },

  // Schedule
  schedule: {
    base: '/api/schedule',
  },

  // Saved Schedules
  savedSchedules: {
    base: '/api/saved-schedules',
    byId: (id) => `/api/saved-schedules/${id}`,
    restore: (id) => `/api/saved-schedules/${id}/restore`,
  },

  // Settings
  settings: {
    base: '/api/settings',
  },

  // Users
  users: {
    base: '/api/users',
    byId: (id) => `/api/users/${id}`,
    password: (id) => `/api/users/${id}/password`,
    activate: (id) => `/api/users/${id}/activate`,
  },
};

// Re-export the configured axios instance from axiosConfig
// This includes authentication interceptors
export { default as api } from '../utils/axiosConfig.js';

export default API_URL;
